/**
 * 监控墙（新 UI）PermissionA5 子树。
 * rootPath: surveillancePage
 */
const surveillancePage = {
  tts: {
    settings: {
      buttonCodes: []
    }
  },
  faceLibrary: {
    buttonCodes: ['sur:babyroom:face']
  }
}

export default surveillancePage
